/* ==========================================================
   CREATE INITIAL FORM
========================================================== */

export default function createInitialForm(request = {}) {
  return {
    /*
    ==========================================================
    COMPANY
    ==========================================================
    */

    companyMode: "new",
    companyId: "",
    companyName: request.companyName || "",

    /*
    ==========================================================
    USER
    ==========================================================
    */

    applicantName: request.name || "",
    applicantEmail: request.email || "",

    /*
    ==========================================================
    ACCESS
    ==========================================================
    */

    role: "",
    enabledModules: [],

    /*
    ==========================================================
    STATUS
    ==========================================================
    */

    approved: false,
    rejected: false
  };
}